/* eslint-disable no-console */

/**
 * Log levels for the structured logger.
 * In production, default is WARN — only warnings and errors are shown.
 * Set to DEBUG during development to see all log output.
 */
export const LogLevel = {
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    none: 4,
} as const;

export type LogLevelValue = (typeof LogLevel)[keyof typeof LogLevel];

let currentLevel: LogLevelValue = LogLevel.warn;

export const logger = {
    debug: (...args: Array<unknown>): void => {
        if (currentLevel <= LogLevel.debug) console.log(...args);
    },
    info: (...args: Array<unknown>): void => {
        if (currentLevel <= LogLevel.info) console.info(...args);
    },
    warn: (...args: Array<unknown>): void => {
        if (currentLevel <= LogLevel.warn) console.warn(...args);
    },
    error: (...args: Array<unknown>): void => {
        if (currentLevel <= LogLevel.error) console.error(...args);
    },
    setLevel: (level: LogLevelValue): void => {
        currentLevel = level;
    },
    getLevel: (): LogLevelValue => currentLevel,
};
